import { toast } from "sonner";
import { api } from "@/lib/api";

/** Opens an authenticated HTML/PDF as a blob in a new tab (or downloads it) – nothing leaves the logged-in session, no public link. */
export async function openBlob(url, download) {
  const r = await api.get(url, { responseType: "blob" });
  const obj = URL.createObjectURL(r.data);
  if (download) {
    const a = document.createElement("a");
    a.href = obj; a.download = download; a.click();
  } else if (!window.open(obj, "_blank")) toast("Nettleseren blokkerte fanen – tillat popups for å åpne dokumentet");
  setTimeout(() => URL.revokeObjectURL(obj), 60_000);
}
